import { ConstraintConfigType } from "types/ConstraintsTypes";
import { ConstraintContent } from "../ConstraintContent";

type MacroContentProps = {
  configData: ConstraintConfigType;
};

export function MacroContent({ configData }: MacroContentProps) {
  return (
    <ConstraintContent
      configData={configData}
      dataKey="macro"
    />
  );
}
